import { Icon } from "@iconify/react/dist/iconify.js";

const DeleteConfirmModal = ({ 
    isOpen, 
    deletingOrg, 
    deleteConfirmText, 
    setDeleteConfirmText, 
    isDeleting, 
    onCancel, 
    onConfirm 
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-background p-4 rounded-lg w-1/3 max-w-md">
                <div className="flex items-center gap-3 mb-4">
                    <Icon icon="mdi:alert-circle" className="text-error text-3xl" />
                    <h2 className="text-xl font-bold text-error">Delete Customer</h2>
                </div>

                <div className="mb-4">
                    <p className="text-font-secondary mb-2">
                        You are about to permanently delete:
                    </p>
                    <div className="rounded card-container">
                        <p className="font-semibold">{deletingOrg?.display_name || deletingOrg?.name}</p>
                        <p className="text-sm text-font-secondary">ID: {deletingOrg?.metadata?.customer_id || deletingOrg?.name}</p>
                    </div>
                </div>

                <div className="mb-4 p-3 border border-error rounded">
                    <p className="text-font-secondary text-sm">
                        <strong className="text-error">Warning:</strong> This action cannot be undone. All organization data, users, and associated resources will be permanently deleted.
                    </p>
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-font-secondary mb-2">
                        Type the customer ID to confirm deletion:
                    </label>
                    <input
                        type="text"
                        value={deleteConfirmText}
                        onChange={(e) => setDeleteConfirmText(e.target.value)}
                        placeholder={deletingOrg?.metadata?.customer_id || deletingOrg?.name}
                        className="w-full p-2 rounded bg-background input-textbox focus:border-error focus:outline-none"
                    />
                </div>

                <div className="flex gap-3 justify-end">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors button-container"
                        disabled={isDeleting}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isDeleting || (deleteConfirmText !== deletingOrg?.metadata?.customer_id && deleteConfirmText !== deletingOrg?.name)}
                        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:bg-gray-600 disabled:cursor-not-allowed transition-colors flex items-center gap-2 button-container"
                    >
                        {isDeleting ? (
                            <>
                                <Icon icon="eos-icons:loading" className="animate-spin responsive-icon-sm" />
                                Deleting...
                            </>
                        ) : (
                            <>
                                <Icon icon="mdi:delete" className="responsive-icon-sm" />
                                Delete Customer
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
